import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { ObrazUser } from '../api/obraz/api.types';
import { apiService } from '../api/apiService';
import { STORE_NAMES } from '../shared/constants';
import { myTracker } from '../shared/utils/myTracker';

type AuthState = {
  user: ObrazUser | null;
  token: string | null;
};

type AuthActions = {
  updateUser: (user: Partial<ObrazUser>) => void;
  logout: () => void;
  loginWithOtp: (
    accessToken: string,
    isNewUser?: boolean,
    email?: string | null
  ) => Promise<void>;
};

type AuthStore = AuthState & AuthActions;

export const useAuthStore = create<AuthStore>()(
  persist(
    set => ({
      token: null,
      user: null,

      updateUser: updates => {
        set(state => ({
          user: state.user ? { ...state.user, ...updates } : null,
        }));
      },

      async loginWithOtp(
        accessToken: string,
        isNewUser = false,
        email
      ): Promise<void> {
        set({ token: accessToken });
        const user = await apiService.obraz.getMe();
        set({ user });
        myTracker.setUserId(user.id);
        if (isNewUser) {
          myTracker.trackRegistration(user.id, email ?? null);
          return;
        }
        myTracker.trackLogin(user.id, email ?? null);
      },

      logout: () => {
        myTracker.clearUserId();
        set({ user: null, token: null });
      },
    }),
    {
      name: STORE_NAMES.AUTH,
      storage: createJSONStorage(() => localStorage),
    }
  )
);
